var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_print_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_print_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0a2 2 0 0 1 2 2v6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2H2a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2V2a2 2 0 0 1 2-2h10Zm0 16H6v4h10v-4Zm4-6H2v8h2v-4h14v4h2v-8Zm-4-8H6v6h10V2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_print_a)",
    transform: "translate(-900 -105)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_print_b)",
    transform: "translate(900 105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h22v22H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/iconPrint.16f0bf68a4b6fdf48e840f7f878849b4.svg";
export { ForwardRef as ReactComponent };